<template>
  <v-card class="default-card">
    <slot name="out-of-box"></slot>
    <slot name="image-box">
      <div v-if="mediaSrc" class="image-box">
        <img :src="`/images/${mediaSrc}`" :alt="imageAlt" loading="lazy" />
      </div>
    </slot>
    <slot>
      <div class="text-box">
        <h2 v-if="secondHeading">{{ secondHeading }}</h2>
        <h3 v-if="thirdHeading">{{ thirdHeading }}</h3>
        <h4 v-if="fourthHeading">{{ fourthHeading }}</h4>
        <p v-if="paragraphText">{{ paragraphText }}</p>
      </div>
    </slot>
    <slot name="action-of-box">
      <v-btn v-if="buttonText" class="default-button" color="primary" @click="$emit('buttonClicked')">
        {{ buttonText }}
      </v-btn>
    </slot>
  </v-card>
</template>

<script setup lang="ts">
import { VCard, VBtn } from 'vuetify/components';

defineProps<{
  mediaSrc?: string,
  imageAlt?: string,
  secondHeading?: string,
  thirdHeading?: string,
  fourthHeading?: string,
  paragraphText?: string,
  buttonText?: string,
}>()
</script>

<style scoped lang="scss">
.default-card {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border-radius: 25px;
  background-color: #FFFFFF;
  margin: 0px auto;
}
</style>